module.exports = __webpack_public_path__ + "public/img/social-logo.4f5d40f8.png";